import {
  faChartColumn,
  faDatabase,
  faDownload,
  faEye,
  faFile,
  faFolderOpen,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import jupyterLogo from 'resources/jupyter_logo.svg';

export const maxHeight = 290;
export const maxWidth = 1248; // change this based on screen width when/if implementing mobile
export const usualMargins: Record<string, number> = {
  top: 0,
  right: 60,
  left: 0,
  bottom: 0,
};

export const icons = {
  faChartColumn: faChartColumn,
  faDatabase: faDatabase,
  faDownload: faDownload,
  faEye: faEye,
  faFile: faFile,
  faFolderOpen: faFolderOpen,
  faUser: faUser,
  faCircleQuestion: faCircleQuestion,
  jupyterLogo: jupyterLogo,
};

export function changeMargins(
  inputMargins: Record<string, number>
): Record<string, number> {
  const returnMargins: Record<string, number> = {};
  Object.keys(usualMargins).map((key) => {
    if (inputMargins[key]) {
      return (returnMargins[key] = usualMargins[key] + inputMargins[key]);
    } else {
      return (returnMargins[key] = usualMargins[key]);
    }
  });
  return returnMargins;
}

export function getCurrKeys(
  data: { [x: string]: string | number }[]
): string[] {
  const allKeys = new Set<string>();

  data.forEach((item) => {
    const currKeys = Object.keys(item);

    currKeys.forEach((key) => {
      allKeys.add(key);
    });
  });

  allKeys.delete('day');
  return Array.from(allKeys);
}

export function getColors(): string[] {
  return ['#093e80', '#1756a7', '#2f71c0', '#2290da', '#16adfe'];
}
